/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AtsJobMappingStatusFromJSON, AtsJobMappingStatusToJSON, } from './AtsJobMappingStatus.js';
/**
 * Check if a given object implements the AtsJobDto interface.
 */
export function instanceOfAtsJobDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function AtsJobDtoFromJSON(json) {
    return AtsJobDtoFromJSONTyped(json, false);
}
export function AtsJobDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'location': json['location'] == null ? undefined : json['location'],
        'status': AtsJobMappingStatusFromJSON(json['status']),
    };
}
export function AtsJobDtoToJSON(json) {
    return AtsJobDtoToJSONTyped(json, false);
}
export function AtsJobDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'location': value['location'],
        'status': AtsJobMappingStatusToJSON(value['status']),
    };
}
